import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c373700c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid row gap-5 p-0 w-100 d-flex" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 cor_texto_1 titulo" }, "File upload", -1))
const _hoisted_4 = { class: "d-flex gap-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content"},
  class: "m-0 fas fa-arrow-left"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"1.125rem"},
  class: "m-0"
}, "Voltar", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "2em",
  fill: "currentColor",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"1.125rem"},
  class: "m-0"
}, "Baixar", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-upload text-red",
  style: {"font-size":"20px"}
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"1.125rem"},
  class: "m-0"
}, "Upload", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "tamanho-maximo container-files bg-white d-flex flex-column" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\" data-v-c373700c><div class=\"d-flex flex-row\" data-v-c373700c><div class=\"imgBack\" data-v-c373700c><svg width=\"30\" height=\"30\" viewBox=\"0 0 60 87\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-c373700c><g data-v-c373700c><g opacity=\"0.3\" data-v-c373700c><path d=\"M34 78.9011C32.8954 78.9011 32 77.6699 32 76.1511C32 74.6323 32.8954 73.4011 34 73.4011H55.9999C58.2091 73.4011 59.9999 75.8635 59.9999 78.9011H34Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M34 67.9011C32.8954 67.9011 32 66.6699 32 65.1511C32 63.6324 32.8954 62.4011 34 62.4011H57.9999C59.1045 62.4011 59.9999 63.6324 59.9999 65.1511C59.9999 66.6699 59.1045 67.9011 57.9999 67.9011H34Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M34 56.9012C32.8954 56.9012 32 55.67 32 54.1512C32 52.6324 32.8954 51.4012 34 51.4012H57.9999C59.1045 51.4012 59.9999 52.6324 59.9999 54.1512C59.9999 55.67 59.1045 56.9012 57.9999 56.9012H34Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M34 45.9012C32.8954 45.9012 32 44.67 32 43.1512C32 41.6324 32.8954 40.4012 34 40.4012H57.9999C59.1045 40.4012 59.9999 41.6324 59.9999 43.1512C59.9999 44.67 59.1045 45.9012 57.9999 45.9012H34Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M34 34.9012C32.8954 34.9012 32 33.67 32 32.1512C32 30.6325 32.8954 29.4012 34 29.4012H57.9999C59.1045 29.4012 59.9999 30.6325 59.9999 32.1512C59.9999 33.67 59.1045 34.9012 57.9999 34.9012H34Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M34 23.9013C32.8954 23.9013 32 22.67 32 21.1513C32 19.6325 32.8954 18.4013 34 18.4013H57.9999C59.1045 18.4013 59.9999 19.6325 59.9999 21.1513C59.9999 22.67 59.1045 23.9013 57.9999 23.9013H34Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M34 12.9013C32.8954 12.9013 32 11.6701 32 10.1513C32 8.63252 32.8954 7.40131 34 7.40131H59.9999C59.9999 10.4389 58.2091 12.9013 55.9999 12.9013L34 12.9013Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M40 10.1513C40 8.63252 40.8954 7.40131 42 7.40131C43.1045 7.40131 44 8.63252 44 10.1513V76.1511C44 77.6699 43.1045 78.9011 42 78.9011C40.8954 78.9011 40 77.6699 40 76.1511V10.1513Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M55.9999 12.9013C55.9999 9.86373 57.7908 7.40131 59.9999 7.40131V78.9011C57.7908 78.9011 55.9999 76.4387 55.9999 73.4011V12.9013Z\" fill=\"#203972\" data-v-c373700c></path></g><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.31949 12.4237L35.3194 0.121115C36.6232 -0.350673 37.9999 0.615196 37.9999 2.00178V84.6701C37.9999 85.9456 36.822 86.8952 35.5756 86.6246L1.57567 79.2431C0.65604 79.0434 0 78.2296 0 77.2886V14.3044C0 13.4622 0.527567 12.7103 1.31949 12.4237ZM23.6336 49.4653L19.6536 55.151L23.6336 60.8368C24.122 61.5351 24.122 62.6664 23.6336 63.3641L22.7491 64.6277C22.2607 65.3254 21.4684 65.3254 20.98 64.6277L17 58.9419L13.0199 64.6277C12.5315 65.3254 11.7392 65.3254 11.2508 64.6277L10.3663 63.3641C9.87787 62.6658 9.87787 61.5345 10.3663 60.8368L14.3463 55.151L10.3663 49.4653C9.87787 48.767 9.87787 47.6357 10.3663 46.938L11.2508 45.6744C11.7396 44.9766 12.5315 44.9766 13.0199 45.6744L17 51.3601L20.98 45.6744C21.4688 44.9766 22.2607 44.9766 22.7491 45.6744L23.6336 46.938C24.122 47.6363 24.122 48.7675 23.6336 49.4653Z\" fill=\"#203972\" data-v-c373700c></path></g></svg></div><div class=\"d-block\" data-v-c373700c><span class=\"subtitulo modal-title\" data-v-c373700c>Histórico de envios</span><p class=\"m-0 legenda\" data-v-c373700c>Lista das últimas 10 planilhas adicionadas</p><p class=\"m-0 legenda\" data-v-c373700c>Manter a quantidade de planilhas abaixo de 1000</p></div></div></div>", 1)
const _hoisted_16 = { class: "modal-body pb-0" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "skeleton-row" }
const _hoisted_19 = {
  key: 1,
  class: "list-group list-group-flush container-lista px-0"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["title"]
const _hoisted_22 = {
  style: {"margin-right":"auto !important"},
  class: "p-1"
}
const _hoisted_23 = {
  key: 0,
  style: {"background":"#dcfce7 !important","color":"#22c55e !important"},
  class: "px-2 py-1 rounded"
}
const _hoisted_24 = {
  key: 1,
  style: {"background":"#fef9c3 !important","color":"#eab308 !important"},
  class: "px-2 py-1 rounded"
}
const _hoisted_25 = {
  key: 2,
  style: {"background":"#fee2e2 !important","color":"#ef4444 !important"},
  class: "px-2 py-1 rounded"
}
const _hoisted_26 = {
  class: "legenda",
  style: {"align-self":"flex-end","margin":"15px"}
}
const _hoisted_27 = { style: {"font-weight":"bold"} }
const _hoisted_28 = { class: "tamanho-maximo container-files bg-white d-flex flex-column" }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\" data-v-c373700c><div class=\"d-flex flex-row\" data-v-c373700c><div class=\"imgBack\" data-v-c373700c><svg width=\"30\" height=\"30\" viewBox=\"0 0 60 87\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-c373700c><g data-v-c373700c><g opacity=\"0.3\" data-v-c373700c><path d=\"M34 78.9011C32.8954 78.9011 32 77.6699 32 76.1511C32 74.6323 32.8954 73.4011 34 73.4011H55.9999C58.2091 73.4011 59.9999 75.8635 59.9999 78.9011H34Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M34 67.9011C32.8954 67.9011 32 66.6699 32 65.1511C32 63.6324 32.8954 62.4011 34 62.4011H57.9999C59.1045 62.4011 59.9999 63.6324 59.9999 65.1511C59.9999 66.6699 59.1045 67.9011 57.9999 67.9011H34Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M34 56.9012C32.8954 56.9012 32 55.67 32 54.1512C32 52.6324 32.8954 51.4012 34 51.4012H57.9999C59.1045 51.4012 59.9999 52.6324 59.9999 54.1512C59.9999 55.67 59.1045 56.9012 57.9999 56.9012H34Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M34 45.9012C32.8954 45.9012 32 44.67 32 43.1512C32 41.6324 32.8954 40.4012 34 40.4012H57.9999C59.1045 40.4012 59.9999 41.6324 59.9999 43.1512C59.9999 44.67 59.1045 45.9012 57.9999 45.9012H34Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M34 34.9012C32.8954 34.9012 32 33.67 32 32.1512C32 30.6325 32.8954 29.4012 34 29.4012H57.9999C59.1045 29.4012 59.9999 30.6325 59.9999 32.1512C59.9999 33.67 59.1045 34.9012 57.9999 34.9012H34Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M34 23.9013C32.8954 23.9013 32 22.67 32 21.1513C32 19.6325 32.8954 18.4013 34 18.4013H57.9999C59.1045 18.4013 59.9999 19.6325 59.9999 21.1513C59.9999 22.67 59.1045 23.9013 57.9999 23.9013H34Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M34 12.9013C32.8954 12.9013 32 11.6701 32 10.1513C32 8.63252 32.8954 7.40131 34 7.40131H59.9999C59.9999 10.4389 58.2091 12.9013 55.9999 12.9013L34 12.9013Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M40 10.1513C40 8.63252 40.8954 7.40131 42 7.40131C43.1045 7.40131 44 8.63252 44 10.1513V76.1511C44 77.6699 43.1045 78.9011 42 78.9011C40.8954 78.9011 40 77.6699 40 76.1511V10.1513Z\" fill=\"#203972\" data-v-c373700c></path><path d=\"M55.9999 12.9013C55.9999 9.86373 57.7908 7.40131 59.9999 7.40131V78.9011C57.7908 78.9011 55.9999 76.4387 55.9999 73.4011V12.9013Z\" fill=\"#203972\" data-v-c373700c></path></g><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.31949 12.4237L35.3194 0.121115C36.6232 -0.350673 37.9999 0.615196 37.9999 2.00178V84.6701C37.9999 85.9456 36.822 86.8952 35.5756 86.6246L1.57567 79.2431C0.65604 79.0434 0 78.2296 0 77.2886V14.3044C0 13.4622 0.527567 12.7103 1.31949 12.4237ZM23.6336 49.4653L19.6536 55.151L23.6336 60.8368C24.122 61.5351 24.122 62.6664 23.6336 63.3641L22.7491 64.6277C22.2607 65.3254 21.4684 65.3254 20.98 64.6277L17 58.9419L13.0199 64.6277C12.5315 65.3254 11.7392 65.3254 11.2508 64.6277L10.3663 63.3641C9.87787 62.6658 9.87787 61.5345 10.3663 60.8368L14.3463 55.151L10.3663 49.4653C9.87787 48.767 9.87787 47.6357 10.3663 46.938L11.2508 45.6744C11.7396 44.9766 12.5315 44.9766 13.0199 45.6744L17 51.3601L20.98 45.6744C21.4688 44.9766 22.2607 44.9766 22.7491 45.6744L23.6336 46.938C24.122 47.6363 24.122 48.7675 23.6336 49.4653Z\" fill=\"#203972\" data-v-c373700c></path></g></svg></div><div class=\"d-block\" data-v-c373700c><span class=\"subtitulo modal-title\" data-v-c373700c>Histórico de downloads</span><p class=\"m-0 legenda\" data-v-c373700c>Lista das últimas 10 planilhas adicionadas</p><p class=\"m-0 legenda\" data-v-c373700c>Manter a quantidade de planilhas abaixo de 1000</p></div></div></div>", 1)
const _hoisted_30 = { class: "modal-body pb-0" }
const _hoisted_31 = {
  key: 0,
  class: "pb-5"
}
const _hoisted_32 = { class: "skeleton-row" }
const _hoisted_33 = {
  key: 1,
  class: "list-group list-group-flush container-lista px-0"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["title"]
const _hoisted_36 = {
  style: {"margin-right":"auto !important"},
  class: "p-1"
}
const _hoisted_37 = {
  key: 0,
  style: {"background":"#dcfce7 !important","color":"#22c55e !important"},
  class: "px-2 py-1 rounded"
}
const _hoisted_38 = {
  key: 1,
  style: {"background":"#fef9c3 !important","color":"#eab308 !important"},
  class: "px-2 py-1 rounded"
}
const _hoisted_39 = {
  key: 2,
  style: {"background":"#fee2e2 !important","color":"#ef4444 !important"},
  class: "px-2 py-1 rounded"
}
const _hoisted_40 = {
  class: "legenda",
  style: {"align-self":"flex-end","margin":"15px"}
}
const _hoisted_41 = { style: {"font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_ModalPlanilhaFiltro = _resolveComponent("ModalPlanilhaFiltro")!
  const _component_ModalDownloadFiltro = _resolveComponent("ModalDownloadFiltro")!
  const _component_ModalUploadFiltro = _resolveComponent("ModalUploadFiltro")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.history.back())),
          class: "btn btn-light-danger bg-white d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center"
        }, _hoisted_7),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.abreModalDownload())),
          class: "btn btn-light-danger bg-white d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center"
        }, _hoisted_10),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.abreModalUpload())),
          class: "btn btn-light-danger bg-white d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center"
        }, _hoisted_13)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        (_ctx.loaderListaUpload)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (n) => {
                return _createVNode(_component_el_skeleton, {
                  rows: 10,
                  animated: "",
                  key: n,
                  style: {"margin-bottom":"10px"}
                }, {
                  template: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"50%"}
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"20%"}
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "button",
                        style: {"width":"80px"}
                      })
                    ])
                  ]),
                  _: 2
                }, 1024)
              }), 64))
            ]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historicoArquivos, (item, key) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: key,
                  onClick: ($event: any) => (_ctx.abreModal(item, 'Upload')),
                  class: "list-group-item d-flex justify-content-between align-items-center gap-3 texto cursor-pointer"
                }, [
                  _createElementVNode("span", {
                    title: item.nome,
                    class: "w-50 p-1 text-truncate inline-block"
                  }, _toDisplayString(item.nome), 9, _hoisted_21),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.formatDate(item.data)), 1),
                  (item.status === 'concluído')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(item.status), 1))
                    : (item.status === 'aguardando')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(item.status), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(item.status), 1))
                ], 8, _hoisted_20))
              }), 128)),
              _createElementVNode("p", _hoisted_26, [
                _createTextVNode("Total planilhas: "),
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.qtdArquivosSalvos), 1)
              ])
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        (_ctx.loaderListaDownload)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (n) => {
                return _createVNode(_component_el_skeleton, {
                  rows: 10,
                  animated: "",
                  key: n,
                  style: {"margin-bottom":"10px"}
                }, {
                  template: _withCtx(() => [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"50%"}
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"20%"}
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "button",
                        style: {"width":"80px"}
                      })
                    ])
                  ]),
                  _: 2
                }, 1024)
              }), 64))
            ]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historicoArquivosDownloads, (item, key) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: key,
                  onClick: ($event: any) => (_ctx.abreModal(item, 'Download')),
                  class: "list-group-item d-flex justify-content-between align-items-center gap-3 texto cursor-pointer"
                }, [
                  _createElementVNode("span", {
                    title: item.nome,
                    class: "w-50 p-1 text-truncate inline-block"
                  }, _toDisplayString(item.nome), 9, _hoisted_35),
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.formatDate(item.data)), 1),
                  (item.status === 'pronto')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(item.status), 1))
                    : (item.status === 'processando')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(item.status), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(item.status), 1))
                ], 8, _hoisted_34))
              }), 128)),
              _createElementVNode("p", _hoisted_40, [
                _createTextVNode("Total planilhas: "),
                _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.qtdArquivosSalvosDownloads), 1)
              ])
            ]))
      ])
    ]),
    _createVNode(_component_ModalPlanilhaFiltro, {
      fechaModal: _ctx.fechaModal,
      arquivo: _ctx.arquivoSelecionado,
      tipo: _ctx.tipoSelecionado,
      rodandoFila: _ctx.rodandoFila,
      pegarListaDePlanilhas: _ctx.pegarListaDePlanilhas
    }, null, 8, ["fechaModal", "arquivo", "tipo", "rodandoFila", "pegarListaDePlanilhas"]),
    _createVNode(_component_ModalDownloadFiltro, {
      marcasFiltro: _ctx.marcas,
      fechaModal: _ctx.fechaModalDownload,
      pegarListaDePlanilhaFiltroDownload: _ctx.pegarListaPlanilhaFiltroDatabase
    }, null, 8, ["marcasFiltro", "fechaModal", "pegarListaDePlanilhaFiltroDownload"]),
    _createVNode(_component_ModalUploadFiltro, {
      marcasFiltro: _ctx.marcas,
      fechaModal: _ctx.fechaModalUpload,
      pegarListaDePlanilhas: _ctx.pegarListaDePlanilhas
    }, null, 8, ["marcasFiltro", "fechaModal", "pegarListaDePlanilhas"])
  ]))
}